import { useModalContext } from 'utils/contexts/modal/context';
import { ContentPreviewPush } from './contentPreviewPush/ContentPreviewPush';
import { ContentPreviewEmail } from './ContentPreviewEmail';
import { ContentPreviewInApp } from './contentPreviewInApp/ContentPreviewInApp';
import { ContentPreviewWebPush } from './contentPreviewWebPush/ContentPreviewWebPush';
import { ContentPreviewWhatsApp } from './contentPreviewWhatsApp/ContentPreviewWhatsApp';
import { ContentPreviewSms } from './contentPreviewSms/ContentPreviewSms';
import { ContentPreviewContainer } from './ContentPreview.styled';

import type {
  TemplateDiffTemplate,
  TemplateDiffContentEmail,
  TemplateDiffContentPush,
  TemplateDiffContentInApp,
  TemplateDiffContentWebPush,
  TemplateDiffContentType,
  TemplateDiffContentSMS,
  TemplateDiffContentWhatsApp,
  TemplateDiffModalState,
} from '../../types';

type ContentPreviewProps = {
  template: TemplateDiffTemplate;
  contentLeft: TemplateDiffContentType;
  contentRight: TemplateDiffContentType;
};

export const ContentPreview = ({ template, contentLeft, contentRight }: ContentPreviewProps) => {
  const { showModal } = useModalContext<TemplateDiffModalState>();

  const onClick = (newContent: TemplateDiffContentType) => {
    showModal({ action: 'restoreTemplateModal', newContent, templateId: template.id });
  };

  switch (true) {
    case !!template.emailContentId:
      return (
        <ContentPreviewContainer data-test="template-diff-content-preview-email">
          <ContentPreviewEmail
            {...(contentLeft as TemplateDiffContentEmail)}
            onClick={onClick}
            templateId={template.id}
          />
          <ContentPreviewEmail
            {...(contentRight as TemplateDiffContentEmail)}
            onClick={onClick}
            templateId={template.id}
          />
        </ContentPreviewContainer>
      );
    case !!template.pushContentId:
      return (
        <ContentPreviewContainer data-test="template-diff-content-preview-push">
          <ContentPreviewPush
            {...(contentLeft as TemplateDiffContentPush)}
            templateId={template.id}
            onClick={onClick}
          />
          <ContentPreviewPush
            {...(contentRight as TemplateDiffContentPush)}
            templateId={template.id}
            onClick={onClick}
          />
        </ContentPreviewContainer>
      );
    case !!template.inAppContentId:
      return (
        <ContentPreviewContainer data-test="template-diff-content-preview-in-app">
          <ContentPreviewInApp
            {...(contentLeft as TemplateDiffContentInApp)}
            templateId={template.id}
            onClick={onClick}
          />
          <ContentPreviewInApp
            {...(contentRight as TemplateDiffContentInApp)}
            templateId={template.id}
            onClick={onClick}
          />
        </ContentPreviewContainer>
      );
    case !!template.smsContentId:
      return (
        <ContentPreviewContainer data-test="template-diff-content-preview-sms">
          <ContentPreviewSms
            {...(contentLeft as TemplateDiffContentSMS)}
            templateId={template.id}
            onClick={onClick}
          />
          <ContentPreviewSms
            {...(contentRight as TemplateDiffContentSMS)}
            templateId={template.id}
            onClick={onClick}
          />
        </ContentPreviewContainer>
      );
    case !!template.webPushContentId:
      return (
        <ContentPreviewContainer data-test="template-diff-content-preview-webpush">
          <ContentPreviewWebPush
            {...(contentLeft as TemplateDiffContentWebPush)}
            templateId={template.id}
            onClick={onClick}
          />
          <ContentPreviewWebPush
            {...(contentRight as TemplateDiffContentWebPush)}
            templateId={template.id}
            onClick={onClick}
          />
        </ContentPreviewContainer>
      );
    case !!template.whatsAppContentId:
      return (
        <ContentPreviewContainer data-test="template-diff-content-preview-whatsapp">
          <ContentPreviewWhatsApp
            {...(contentLeft as TemplateDiffContentWhatsApp)}
            templateId={template.id}
          />
          <ContentPreviewWhatsApp
            {...(contentRight as TemplateDiffContentWhatsApp)}
            templateId={template.id}
          />
        </ContentPreviewContainer>
      );
    default:
      return null;
  }
};
